import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import UIStore from '../stores/UIStore';

const XsSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (UIStore.notification.message) {
      const isError = UIStore.notification.variant === 'error';
      enqueueSnackbar(UIStore.notification.message, {
        variant: UIStore.notification.variant,
        autoHideDuration: isError ? 10000 : 5000
      });
      // Reset after enqueueing so the same message doesn't re-fire
      UIStore.setNotificationMessage('', 'default');
    }
  }, [UIStore.notification.message, UIStore.notification.variant]);

  return null;
};

export default observer(XsSnackbar);
